interface WarningDialogState {
  open: boolean
  title: string
  description: string
  buttonText: string
  extras?: VNode
  resolver: (v: unknown) => void
}

export function useWarning() {
  const state = useState<WarningDialogState>('WarningDialog', () => ({
    open: false,
    title: '',
    description: '',
    buttonText: '',
    extras: undefined,
    resolver: () => {},
  }))

  async function warning({
    title = 'Warning',
    description = 'This action is forbidden',
    buttonText = 'Ok',
    extras,
  }: Partial<WarningDialogState>) {
    if (import.meta.server) return false
    state.value = {
      ...state.value,
      open: true,
      title,
      description,
      buttonText,
      extras,
    }
    await new Promise(resolve => {
      state.value.resolver = resolve
    })
    state.value.resolver = () => {}
    state.value.open = false
  }

  function resolve() {
    state.value.resolver(null)
  }

  return {
    state,
    warning,
    resolve,
  }
}
